import { FrameCore } from "@/hz/core";
import float_temp from "@/template/floating.hz?raw";

export class FloatingController extends FrameCore {
  constructor(element: HTMLElement) {
    super(element);
  }

  init(): void {
    this.insert(float_temp);
  }

  goto(n: string): void {
    console.log("FloatingController.goto", n);
  }

  show(): void {
    const elem = document.querySelector(".c-not-auth") as HTMLElement;
    elem.style.display = "block";
  }

  hide(): void {
    const elem = document.querySelector(".c-not-auth") as HTMLElement;
    elem.style.display = "none";
  }
}
